<p>product-details-cell works!</p>
